import { apiSlice } from "../apiSlice";

export interface DefaultCommissionData {
  commission: number;
}

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;

export const commissionService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDefaultCartCommission: builder.query<
      {
        defaultCommission: number;
      },
      void
    >({
      query: () => ({
        url: `https://superadminhttps-getdefaultcartcommission-${API_BASE_DOMAIN}-uc.a.run.app`,
        method: "GET",
      }),
    }),

    updateDefaultCartCommission: builder.mutation<
      { updatedCommission: number },
      { commission: number }
    >({
      query: ({ commission }) => ({
        url: `https://superadminhttps-updatedefaultcartcommission-${API_BASE_DOMAIN}-uc.a.run.app`,
        method: "PUT",
        body: { commission },
        responseHandler: (response) => response.text(),
      }),
    }),
  }),
});

export const {
  useGetDefaultCartCommissionQuery,
  useLazyGetDefaultCartCommissionQuery,
  useUpdateDefaultCartCommissionMutation,
} = commissionService;
